import { dispatchAnalyticsEvent } from "../../../../../utils";

export const dispatchTradeInSearchSelect = (
  term: string,
  suggestion: string,
) => {
  dispatchAnalyticsEvent(
    "tradeIn.search",
    {
      searchData: {
        type: "typeahead search",
        subType: "trade in",
        term,
        suggestion,
      },
    },
    {},
  );
};

export const dispatchTradeInYourDevice = () => {
  dispatchAnalyticsEvent(
    "global.interaction",
    {
      type: "pdp",
      subType: "trade in your device cta",
      additionalInfo: {},
      properties: {},
      products: [],
    },
    {},
  );
};
